<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter BookTitlePage"><div class="title-block-book"><p class="title-author">John Muir</p> <h1>THE WILDERNESS JOURNEYS</h1> <p class="title-sub">The Story of <br/> My Boyhood and Youth</p> <p class="title-sub">A Thousand Mile Walk to the Gulf</p> <p class="title-sub">My First Summer in the Sierra</p> <p class="title-sub">Travels in Alaska</p> <p class="title-sub">Stickeen</p> <p class="title-other"><i>Introduced by Graham White </i></p></div> <div class="imprint"><p><img alt="alt" src="logo.png"/></p></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847675705_booktitlepage.vue?6350ff50